export default __webpack_public_path__ + "static/australia_icon-5f32075a92df2d7f8f7dbd0637b983b7.png";